import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import type { Rarity } from '@sorare/core/src/__generated__/globalTypes';
import { ScarcityIcon } from '@sorare/core/src/atoms/icons/ScarcityIcon';
import { TextSwitch } from '@sorare/core/src/atoms/inputs/TextSwitch';
import { Horizontal } from '@sorare/core/src/atoms/layout/flex';
import { useScreenSize } from '@sorare/core/src/hooks/device/useScreenSize';
import { scarcityMessages } from '@sorare/core/src/lib/scarcity';

import { SelectRarity } from 'atoms/SelectRarity';

const Label = styled(Horizontal)`
  align-items: center;
  padding: 0 var(--half-unit);
`;

type Props<T extends Rarity> = {
  rarities: T[];
  selectedRarity: T;
  onChange: (rarity: T) => void;
  withoutLabel?: boolean;
};

export const TextSwitchRarity = <T extends Rarity>({
  rarities,
  selectedRarity,
  onChange,
  withoutLabel = false,
}: Props<T>) => {
  const { up: upToTablet } = useScreenSize('tablet');
  if (upToTablet) {
    return (
      <TextSwitch
        options={rarities.map(r => ({
          label: (
            <Label as="span">
              <ScarcityIcon rarity={r} size={2} />
              {!withoutLabel && selectedRarity === r && (
                <FormattedMessage {...scarcityMessages[r]} />
              )}
            </Label>
          ),
          value: r,
        }))}
        value={selectedRarity}
        onChange={onChange}
        onlyGrowOnSelected
        transparent
        compact
      />
    );
  }
  return (
    <SelectRarity
      rarities={rarities}
      selectedRarity={selectedRarity}
      onChange={onChange}
      buttonSize="compact"
    />
  );
};
